import { Pressable, StyleSheet, Text, View } from 'react-native';
import { useUnistyles } from 'react-native-unistyles';
import FontAwesome5 from "@react-native-vector-icons/fontawesome5";
import { Query } from '@/utils/react-query/Queries';
import { useRouter } from 'expo-router';

export default function LibraryScreen(){
    
    /*** State ***/
    
    /*** Theme & Dimensions ***/
    const {theme: {colors}} = useUnistyles();
    const router = useRouter();

    const {data: loggedInUser} = Query.people.loggedInUser()

    if(!loggedInUser?.can?.("View Library")){
        router.back();
        return null;
    }


    return (
        <View style={{padding:10, alignItems:"center", }}>
            <View style={{marginVertical:20, maxWidth:700}}>
                <Pressable style={{...styles.card,}} onPress={() => {
                    router.push({pathname:`/files`})
                }}>
                    <Text style={{...styles.heading}}>Files</Text>
                    <Text style={{...styles.text}}>File storage for your organization.</Text>
                    <FontAwesome5 name="folder" size={100} color={colors.background} iconStyle="solid" style={{position:'absolute', bottom:-25, right:-10, opacity:0.25}} />
                </Pressable>

                <Pressable style={{...styles.card}} onPress={() => router.push({pathname:"/music/songs"})}>
                    <Text style={{...styles.heading}}>Music</Text>
                    <Text style={{...styles.text}}>Song management for your music team that can be added to setlists on events.</Text>
                    <FontAwesome5 name="guitar" size={100} color={colors.background} style={{position:'absolute', bottom:-20, right:-10, opacity:0.25}} />
                </Pressable>

                <Pressable style={{...styles.card}} onPress={() => router.push({pathname:"/library/links"})}>
                    <Text style={{...styles.heading}}>Links</Text>
                    <Text style={{...styles.text}}>Store useful links and associated metadata that can be used elsewhere in the app.</Text>
                    <FontAwesome5 name="link" size={90} color={colors.background} style={{position:'absolute', bottom:-20, right:-10, opacity:0.25}} />
                </Pressable>
            </View>
        </View>
    );
}

const styles = StyleSheet.create(({colors}) => ({
    card:{
        borderRadius:8,
        padding:15,
        paddingVertical:20,
        shadowColor: '#000', 
        shadowOffset: { width: 0, height: 3 }, 
        shadowOpacity: 0.3, 
        shadowRadius: 3, 
        marginVertical:5,
        overflow:"hidden",
        backgroundColor:colors.surface
    },
    heading: {
        color:colors.text, 
        fontSize:14,
        fontWeight:"bold",
        textTransform:"uppercase"
    },
    text:{
        color:colors.textSecondary, 
        fontSize:12,
        marginTop:5,
        fontStyle:"italic",
        paddingRight:40,
    }
}))